import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) {
    // Redirect to landing page - admin routes are hidden
    return <Navigate to="/" replace />;
  }
  return children;
} 